<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/accounting/tax-invoice" v-if="!taxAccess.includes(user.username)">
                    <icon name="file-invoice"></icon>
                    &nbsp;ใบกำกับภาษี-การขาย
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/tax-payment" v-if="!taxAccess.includes(user.username)">
                    <icon name="file-invoice"></icon>
                    &nbsp;ใบกำกับภาษีซื้อ
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/tax-payment-account" v-if="!taxAccess.includes(user.username)">
                    <icon name="file-invoice"></icon>
                    &nbsp;รหัสบัญชีสำหรับภาษีซื้อ
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/billing-RE" v-if="!taxAccess.includes(user.username)">
                    <icon name="file-invoice-dollar"></icon>
                    &nbsp;ใบเสร็จรับเงิน
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/credit-note" v-if="!taxAccess.includes(user.username)">
                    <icon name="file-invoice-dollar"></icon>
                    &nbsp;ใบลดหนี้
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/tax-customer" v-if="this.user">
                    <icon name="file-invoice-dollar"></icon>
                    &nbsp;หักภาษี ณ ที่จ่าย
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/accounting/tax-customer-info" v-if="this.user">
                    <icon name="file-invoice-dollar"></icon>
                    &nbsp;ผู้ถูกหักภาษี
                </b-nav-item>&nbsp;
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view/>
        </div>
    </div>
</template>

<script>
import {
    canCustomerCustomersSpecialView,
    canCustomerCustomersView,
    canCustomerView,
    canInventoryMaterialsView,
    canInventoryOverviewView,
    canInventoryProductsView, canInventoryReportsProductsView, canInventoryReportsView, canInventorySheetsView,
    canInventoryView, canSaleOrdersAllView, canSaleView, canVendorsView, canViewAccounting,
    canViewDashboard, canViewDriver, canViewDriverAll, canViewHR, canViewPurchases,
    canViewSuperAdmin, canViewTransports, hideWarehouseLead
} from "@/util/Permissions";
import {mapState} from "vuex";

export default {
    name: "tax-invoice-layout",
    data() {
        return {
            taxAccess: [
                // "20682"
            ]
        };
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        })
    },
}
</script>

<style scoped>

</style>
